import React, { useState } from 'react';
import PrimaryTable from "../../../../Shared/components/PrimaryTable";
import { LinkProductsListHead } from "../../../../../config/constant";
import { TableCell, TableRow, } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { NavLink } from "react-router-dom";
import { Row, Col, Space } from "antd";
import { Typography, Box } from "@mui/material";

export const ProductView = (props) => {
    const classes = customStyles();
    const [visible, setVisible] = useState(false);
    const { details } = props;
    const [useMrp, setUseMrp] = useState(false);
    const [form, setForm] = useState({});


    const onView = (data) => {
        setVisible(true);
        setForm({
            "productName": data?.productName,
            "description": data?.description !== null && data?.description !== '' ? data?.description : '',
            "type": data?.type,
            "productId": data?.productId,
            "catalogueId": data?.catalogue?.catalogueName,
            "categoryId": data?.category?.categoryName,
            "hsnId": data?.hsn?.hsnCode,
            "productGstId": data?.productGst?.code,
            "skuUnitId": data?.skuUnit?.name,
            "skuQuantity": parseInt(data?.skuQuantity),
            "status": data?.status,
            "mrp": data?.mrp,
        });
        setUseMrp(data?.useMrp);
    }
    return (
        <>
            <PrimaryTable
                heads={LinkProductsListHead}
                details={details}
                customClasses={clsx(classes.margin30t, classes.catelogueProducts)}
                component={
                    <>
                        {
                            details && details.length > 0 ? details.map((data, i) => (
                                <TableRow>
                                    <TableCell>{`${data?.productId || '---'}`}</TableCell>
                                    <TableCell><NavLink to={"#"} onClick={() => onView(data)} className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.PaddingRight50, classes.disBlock, classes.bold)}>{data?.productName}</NavLink></TableCell>
                                    <TableCell>{`${data?.type || '---'}`}</TableCell>
                                    <TableCell>{`${data?.skuQuantity || '---'}`}</TableCell>
                                    <TableCell>{`${data?.skuUnit?.name || '---'}`}</TableCell>
                                    <TableCell>{`${data?.hsn?.hsnCode || '---'}`}</TableCell>
                                    <TableCell>{`${data?.productGst?.code || '---'}`}</TableCell>
                                </TableRow>
                            )) : <TableRow><TableCell style={{ textAlign: "center" }} colspan={7}>No Products Found</TableCell></TableRow>
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => setVisible(false)}
                title={`View Product`}
                width={'690px'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="div">
                        <div className={classes.customFormFlex}>
                            <Row type="flex" gutter={40}>
                                <Col xxl={16} xl={16} lg={16} md={16} sm={12} xs={24}>
                                    <Row type="flex">
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product ID</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.productId}</Typography>
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Name</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.productName}</Typography>
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description}</Typography>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={16} style={{ height: "100%" }} className={classes.feature}>
                                    <div className={clsx(classes.productImageUpload)}>
                                        <div className={classes.productImageUploadInner}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, classes.fonSize13)}>Product Image</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'---'}</Typography>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row type="flex" gutter={40} className={classes.younoteAdminProduct}>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Catalogue Name</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.catalogueId || '---'}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Category Name</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.categoryId || '---'}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Type</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.type || '---'}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Quantity</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.skuQuantity}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Unit</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.skuUnitId || '---'}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product GST Code</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.productGstId || '---'}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.status}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>HSN Code</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.hsnId || '---'}</Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Space direction="horizontal" align="center" className={clsx(classes.customLink, classes.margin35t)}>
                                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Prices</Typography>
                                    </Space>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Use MRP</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{useMrp ? 'Yes' : 'No'} </Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>MRP</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.mrp || '---'}</Typography>
                                </Col>
                            </Row>
                        </div>
                    </Box>
                }
            />
        </>
    )
}